import React from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';

type DepartmentProps = {
  department: string;
};

export const Department: React.FC<DepartmentProps> = ({ department }) => {
  const { t } = useTranslation();
  return (
    <Typography data-qa="division-name" color="text-primary" variant="caption">
      {t('product-info.stocks.in-stores.department')} «{department}»
    </Typography>
  );
};
